/**
 * Merge incremental de arrays de estoque no sync parcial (por loja).
 * Substitui apenas linhas cuja chave (COD_LOJA + COD_PRODUTO) aparece no batch novo.
 */

export function stockRowMergeKey(row: { COD_LOJA?: number | null; COD_PRODUTO?: unknown }): string {
  const loja = row.COD_LOJA == null ? '∅' : String(Number(row.COD_LOJA));
  const prod = Number(row.COD_PRODUTO);
  return `${loja}::${Number.isFinite(prod) ? prod : '∅'}`;
}

export function mergeEstoquePreserveExistingStores(existing: unknown, incoming: unknown): any[] {
  const prev = Array.isArray(existing) ? existing : [];
  const next = Array.isArray(incoming) ? incoming : [];
  if (!next.length) return prev;

  const replaced = new Set(next.map((r) => stockRowMergeKey(r)));
  const kept = prev.filter((r) => !replaced.has(stockRowMergeKey(r)));
  return [...kept, ...next];
}
